import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate } from 'react-router-dom';
import './TIJSidebar.css';



import Laserco2 from './Laserco2';
import Laserfiber from './Laserfiber';
import Laseruv from './Laseruv';

const Laserlayout = ({ mode }) => {
  // Use URL parameter or default to the provided mode or 'co2-zar-laser'
  const { type } = useParams();
  const navigate = useNavigate();
  const [activeComponent, setActiveComponent] = useState(type || mode || 'laser-co2-printers');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Update URL when activeComponent changes
  useEffect(() => {
    navigate(`/laser-printer/${activeComponent}`);
  }, [activeComponent, navigate]);

  // Handle component switching
  const handleComponentChange = (component) => {
    setActiveComponent(component);
    setIsSidebarOpen(false);
  };

  // Render the active component
  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'laser-co2-printers':
        return <Laserco2/>;
      case 'laser-fiber-printers':
        return <Laserfiber/>;
      case 'laser-uv-printers':
        return <Laseruv/>;
      default:
        return <Laserco2/>;
    }
  };

  return (
    <div className="page-container">
      <div className="content-wrap">
      
        {/* Mobile Navigation (Horizontal) */}
        <div className="mobile-nav">
          <button
            className={`nav-link ${activeComponent === 'laser-co2-printers' ? 'active' : ''}`}
            onClick={() => handleComponentChange('laser-co2-printers')}
          >
            ZAR-Laser CO <sub>2</sub>
          </button>
          <button
            className={`nav-link ${activeComponent === 'laser-fiber-printers' ? 'active' : ''}`}
            onClick={() => handleComponentChange('laser-fiber-printers')}
          >
            ZAR-Laser Fiber
          </button>
          <button
            className={`nav-link ${activeComponent === 'laser-uv-printers' ? 'active' : ''}`}
            onClick={() => handleComponentChange('laser-uv-printers')}
          >
            ZAR-Laser UV
          </button>
          
        </div>

        {/* Hamburger Menu Toggle Button (Visible on Small Screens) */}
        <button
          className="sidebar-toggle"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          ☰
        </button>

        {/* Sidebar */}
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="mb-3 ml-4 mt-3" style={{fontSize:"18px", fontWeight:"bold", textDecoration:"underline"}}>ZAR-Laser Printers</div>
          <nav className="nav flex-column">
            <button
              className={`nav-link ${activeComponent === 'laser-co2-printers' ? 'active' : ''}`}
              onClick={() => handleComponentChange('laser-co2-printers')}
            >
              ZAR-Laser CO <sub>2</sub>
            </button>
            <button
              className={`nav-link ${activeComponent === 'laser-fiber-printers' ? 'active' : ''}`}
              onClick={() => handleComponentChange('laser-fiber-printers')}
            >
             ZAR-Laser Fiber
            </button>
            <button
              className={`nav-link ${activeComponent === 'laser-uv-printers' ? 'active' : ''}`}
              onClick={() => handleComponentChange('laser-uv-printers')}
            >
             ZAR-Laser UV 
            </button>
            
          </nav>
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
};

export default Laserlayout;